export const macros = (dealSelected, startDateTriggers, endDateTriggers, selectedMacroType) => {
    const dateMathMacros = {};

    dateMathMacros.dealId = dealSelected?.id || 0;
    dateMathMacros.macroType = selectedMacroType?.value  || 'HoldBack';


    dateMathMacros.startDateStatus = 'f';
    dateMathMacros.startDate = startDateTriggers.useExistingStartDate ? 'date' : 'dateMath'
    dateMathMacros.startTriggerYears = !startDateTriggers.useExistingStartDate ? startDateTriggers.years : '';
    dateMathMacros.startTriggerMonths = !startDateTriggers.useExistingStartDate ? startDateTriggers.months : '';
    dateMathMacros.startTriggerWeeks = !startDateTriggers.useExistingStartDate ? startDateTriggers.weeks : '';
    dateMathMacros.startTriggerDays = !startDateTriggers.useExistingStartDate ? startDateTriggers.days : '';
    dateMathMacros.startTriggerDayType = !startDateTriggers.useExistingStartDate ? startDateTriggers.dayType : '';
    dateMathMacros.startBeforeOrAfter = startDateTriggers.useExistingStartDate ? 'Before' : startDateTriggers?.beforeAfter?.value;

    dateMathMacros.endDateStatus = 'f';
    dateMathMacros.endDate = endDateTriggers.useExistingEndDate ? 'date' : 'dateMath'
    dateMathMacros.endTriggerYears = !endDateTriggers.useExistingEndDate ? endDateTriggers.years : '';
    dateMathMacros.endTriggerMonths = !endDateTriggers.useExistingEndDate ? endDateTriggers.months : '';
    dateMathMacros.endTriggerWeeks = !endDateTriggers.useExistingEndDate ? endDateTriggers.weeks : '';
    dateMathMacros.endTriggerDays = !endDateTriggers.useExistingEndDate ? endDateTriggers.days : '';
    dateMathMacros.endTriggerDayType = !endDateTriggers.useExistingEndDate ? endDateTriggers.dayType : '';
    dateMathMacros.endBeforeOrAfter = endDateTriggers.useExistingEndDate ? 'After' : endDateTriggers?.beforeAfter?.value;




    // Filter out any properties with empty values from the dateMathMacros object
    return Object.fromEntries(
        Object.entries(dateMathMacros).filter(
            ([_, value]) => value !== undefined && value !== null && value !== '',
        ),
    );
};
